import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getTeams({ commit }, payload = {
        paginate: '',
        query: ''}) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_OUTDOORS_LOCALIZATION_TEAMS_REQUEST')

        return axios
            .get(`/outdoors/outdoor-localization-teams${paginate}${query}`)
            .then(response => {
                commit('GET_OUTDOORS_LOCALIZATION_TEAMS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_OUTDOORS_LOCALIZATION_TEAMS_FAILURE')
                handleApiError(error, 'Pobranie ekip nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getTeam(context, id) {
        return axios
            .get(`/outdoors/outdoor-localization-teams/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych dla ekipy ${id} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    createTeam({ commit }, payload) {
        return axios
            .post('/outdoors/outdoor-localization-teams', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Ekipa została dodana.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie ekipy nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateTeam({ commit }, payload) {
        return axios
            .put(`/outdoors/outdoor-localization-teams/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Ekipa została zedytowana.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zapis ekipy nie powiódł się.')

                return Promise.reject(error)
            })
    },
    deleteTeam({ commit }, id) {
        return axios
            .delete(`/outdoors/outdoor-localization-teams/${id}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Usunięto ekipę.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie ekipy nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setTeamFilters({ commit }, filters) {
        commit('SET_TEAMS_FILTERS', filters)
    },
    clearTeamFilters({ commit }) {
        commit('CLEAR_TEAMS_FILTERS')
    }
}